import { render, staticRenderFns } from "./storeDetails.vue?vue&type=template&id=39a4c9ea&"
import script from "./storeDetails.vue?vue&type=script&lang=js&"
export * from "./storeDetails.vue?vue&type=script&lang=js&"
import style0 from "./storeDetails.vue?vue&type=style&index=0&id=39a4c9ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInnerLoading} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInnerLoading})
